(function () {
    const cfg = window.rocketShop || {};
    const i18n = cfg.i18n || {};

    function wcAjax(endpoint) {
        const base = cfg.wcAjaxUrl || '/?wc-ajax=%%endpoint%%';
        return base.replace('%%endpoint%%', endpoint);
    }

    function ensureToast() {
        return document.querySelector('[data-shop-toast]');
    }

    function showToast(message) {
        const toast = ensureToast();
        if (!toast) {
            return;
        }

        const text = toast.querySelector('[data-shop-toast-text]');
        if (text) {
            text.textContent = message;
        }

        toast.hidden = false;
        toast.classList.add('is-visible');

        window.clearTimeout(showToast._timer);
        showToast._timer = window.setTimeout(() => {
            hideToast();
        }, 4200);
    }

    function hideToast() {
        const toast = ensureToast();
        if (!toast) {
            return;
        }
        toast.classList.remove('is-visible');
        toast.hidden = true;
    }

    async function addToCart(payload) {
        const body = new URLSearchParams();
        Object.keys(payload).forEach((key) => {
            if (payload[key] !== undefined && payload[key] !== null && payload[key] !== '') {
                body.append(key, String(payload[key]));
            }
        });

        const response = await fetch(wcAjax('add_to_cart'), {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            },
            body: body.toString(),
        });

        const data = await response.json().catch(() => null);

        if (!response.ok || !data || data.error) {
            const message = (data && data.error && data.error.message) || i18n.error || 'Error';
            throw new Error(message);
        }

        if (data.fragments && window.jQuery) {
            const $ = window.jQuery;
            $.each(data.fragments, (selector, html) => {
                $(selector).replaceWith(html);
            });
            $(document.body).trigger('wc_fragments_refreshed');
            $(document.body).trigger('added_to_cart', [data.fragments, data.cart_hash, null]);
        }

        return data;
    }

    function setButtonLoading(btn, loading) {
        if (!btn) {
            return;
        }
        btn.classList.toggle('loading', loading);
        btn.disabled = !!loading;
        if (loading) {
            btn.dataset.originalLabel = btn.textContent || '';
            btn.textContent = i18n.adding || '…';
        } else if (btn.dataset.originalLabel) {
            btn.textContent = btn.dataset.originalLabel;
            delete btn.dataset.originalLabel;
        }
    }

    // —— Variation modal ——
    let modalState = {
        productId: 0,
        productName: '',
        attributes: [],
        variations: [],
        selected: {},
        variationId: 0,
    };

    function getModal() {
        return document.querySelector('[data-shop-variant-modal]');
    }

    function openModal() {
        const modal = getModal();
        if (!modal) {
            return;
        }
        modal.hidden = false;
        document.body.classList.add('shop-variant-modal-open');
        const closeBtn = modal.querySelector('[data-shop-variant-close]');
        if (closeBtn) {
            closeBtn.focus();
        }
    }

    function closeModal() {
        const modal = getModal();
        if (!modal) {
            return;
        }
        modal.hidden = true;
        document.body.classList.remove('shop-variant-modal-open');
        modalState = {
            productId: 0,
            productName: '',
            attributes: [],
            variations: [],
            selected: {},
            variationId: 0,
        };
    }

    function stripHtml(html) {
        const el = document.createElement('div');
        el.innerHTML = html || '';
        return (el.textContent || '').trim();
    }

    function findMatchingVariation() {
        const selected = modalState.selected;
        const attrs = modalState.attributes;

        const allChosen = attrs.every((attr) => selected[attr.key]);
        if (!allChosen) {
            return null;
        }

        return (
            modalState.variations.find((variation) => {
                const vAttrs = variation.attributes || {};
                return attrs.every((attr) => {
                    const wanted = selected[attr.key];
                    const actual = vAttrs[attr.key];
                    // Empty variation attr = "any"
                    return !actual || actual === wanted;
                });
            }) || null
        );
    }

    function syncVariationUI() {
        const modal = getModal();
        if (!modal) {
            return;
        }

        const match = findMatchingVariation();
        const submit = modal.querySelector('[data-shop-variant-submit]');
        const error = modal.querySelector('[data-shop-variant-error]');
        const price = modal.querySelector('[data-shop-variant-price]');
        const media = modal.querySelector('[data-shop-variant-media]');
        const image = modal.querySelector('[data-shop-variant-image]');

        modalState.variationId = match ? match.variation_id : 0;

        if (error) {
            error.hidden = true;
            error.textContent = '';
        }

        if (match) {
            if (price && match.price_html) {
                price.innerHTML = match.price_html;
            }
            if (media && image && match.image) {
                image.src = match.image;
                media.hidden = false;
            }
            if (submit) {
                const ok = match.is_in_stock && match.is_purchasable;
                submit.disabled = !ok;
                if (!ok && error) {
                    error.hidden = false;
                    error.textContent = i18n.outOfStock || 'Out of stock';
                }
            }
            return;
        }

        if (submit) {
            submit.disabled = true;
        }

        const allChosen = modalState.attributes.every((attr) => modalState.selected[attr.key]);
        if (allChosen && error) {
            error.hidden = false;
            error.textContent = i18n.chooseOptions || 'Choose options';
        }
    }

    function renderVariantFields(payload) {
        const modal = getModal();
        if (!modal) {
            return;
        }

        const fields = modal.querySelector('[data-shop-variant-fields]');
        const title = modal.querySelector('[data-shop-variant-title]');
        const price = modal.querySelector('[data-shop-variant-price]');
        const media = modal.querySelector('[data-shop-variant-media]');
        const image = modal.querySelector('[data-shop-variant-image]');
        const submit = modal.querySelector('[data-shop-variant-submit]');
        const error = modal.querySelector('[data-shop-variant-error]');

        if (title) {
            title.textContent = payload.name || '';
        }
        if (price) {
            const html = payload.price_html || '';
            if (html) {
                price.innerHTML = html;
            } else {
                price.textContent = payload.price_label || '';
            }
        }
        if (media && image) {
            if (payload.image) {
                image.src = payload.image;
                media.hidden = false;
            } else {
                media.hidden = true;
                image.removeAttribute('src');
            }
        }
        if (error) {
            error.hidden = true;
            error.textContent = '';
        }
        if (submit) {
            submit.disabled = true;
            submit.textContent = 'Į krepšelį';
        }

        if (!fields) {
            return;
        }

        fields.innerHTML = '';
        (payload.attributes || []).forEach((attr) => {
            const wrap = document.createElement('div');
            wrap.className = 'shop-variant-modal__field';

            const label = document.createElement('p');
            label.className = 'shop-variant-modal__label';
            label.textContent = attr.label;

            const chips = document.createElement('div');
            chips.className = 'shop-variant-modal__chips';
            chips.setAttribute('role', 'group');
            chips.setAttribute('aria-label', attr.label);

            (attr.options || []).forEach((opt) => {
                const chip = document.createElement('button');
                chip.type = 'button';
                chip.className = 'shop-variant-modal__chip';
                chip.textContent = opt.label;
                chip.dataset.value = opt.value;
                chip.setAttribute('aria-pressed', 'false');

                chip.addEventListener('click', () => {
                    const already = modalState.selected[attr.key] === opt.value;
                    chips.querySelectorAll('.shop-variant-modal__chip').forEach((node) => {
                        node.classList.remove('is-active');
                        node.setAttribute('aria-pressed', 'false');
                    });

                    if (already) {
                        delete modalState.selected[attr.key];
                    } else {
                        modalState.selected[attr.key] = opt.value;
                        chip.classList.add('is-active');
                        chip.setAttribute('aria-pressed', 'true');
                    }
                    syncVariationUI();
                });

                chips.appendChild(chip);
            });

            wrap.appendChild(label);
            wrap.appendChild(chips);
            fields.appendChild(wrap);
        });
    }

    async function openVariantModal(productId, productName) {
        const modal = getModal();
        if (!modal || !cfg.ajaxUrl) {
            return;
        }

        openModal();
        const fields = modal.querySelector('[data-shop-variant-fields]');
        if (fields) {
            fields.innerHTML = '<p class="shop-variant-modal__loading">…</p>';
        }
        const title = modal.querySelector('[data-shop-variant-title]');
        if (title) {
            title.textContent = productName || '';
        }

        try {
            const url = new URL(cfg.ajaxUrl, window.location.origin);
            url.searchParams.set('action', 'rocket_shop_product_modal');
            url.searchParams.set('product_id', String(productId));

            const response = await fetch(url.toString(), { credentials: 'same-origin' });
            const json = await response.json();

            if (!json || !json.success || !json.data) {
                throw new Error((json && json.data && json.data.message) || i18n.error);
            }

            const payload = json.data;
            modalState = {
                productId: payload.id,
                productName: payload.name,
                attributes: payload.attributes || [],
                variations: payload.variations || [],
                selected: {},
                variationId: 0,
            };

            renderVariantFields(payload);
            syncVariationUI();
        } catch (err) {
            closeModal();
            showToast(err.message || i18n.error || 'Error');
        }
    }

    function initCartInteractions() {
        document.addEventListener('click', async (event) => {
            const toastClose = event.target.closest('[data-shop-toast-close]');
            if (toastClose) {
                hideToast();
                return;
            }

            const variantClose = event.target.closest('[data-shop-variant-close]');
            if (variantClose) {
                closeModal();
                return;
            }

            const openBtn = event.target.closest('[data-shop-open-variants]');
            if (openBtn) {
                event.preventDefault();
                const id = Number(openBtn.getAttribute('data-shop-open-variants') || 0);
                const name = openBtn.getAttribute('data-product-name') || '';
                if (id) {
                    openVariantModal(id, name);
                }
                return;
            }

            const addBtn = event.target.closest('[data-shop-add-to-cart]');
            if (addBtn) {
                event.preventDefault();
                const id = Number(addBtn.getAttribute('data-shop-add-to-cart') || 0);
                const name = addBtn.getAttribute('data-product-name') || '';
                if (!id || addBtn.disabled) {
                    return;
                }

                setButtonLoading(addBtn, true);
                try {
                    await addToCart({ product_id: id, quantity: 1 });
                    showToast(
                        name
                            ? `${i18n.added || 'Added'}: ${name}`
                            : i18n.added || 'Added'
                    );
                } catch (err) {
                    showToast(err.message || i18n.error || 'Error');
                } finally {
                    setButtonLoading(addBtn, false);
                }
                return;
            }

            const submit = event.target.closest('[data-shop-variant-submit]');
            if (submit) {
                event.preventDefault();
                if (submit.disabled || !modalState.variationId) {
                    const error = getModal()?.querySelector('[data-shop-variant-error]');
                    if (error) {
                        error.hidden = false;
                        error.textContent = i18n.chooseOptions || 'Choose options';
                    }
                    return;
                }

                setButtonLoading(submit, true);
                try {
                    // WC ?wc-ajax=add_to_cart only accepts a variation as product_id
                    // (it ignores variation_id when product_id is the parent variable).
                    const payload = {
                        product_id: modalState.variationId,
                        quantity: 1,
                    };

                    const nameForToast = modalState.productName;
                    await addToCart(payload);
                    closeModal();
                    showToast(
                        nameForToast
                            ? `${i18n.added || 'Added'}: ${nameForToast}`
                            : i18n.added || 'Added'
                    );
                } catch (err) {
                    const error = getModal()?.querySelector('[data-shop-variant-error]');
                    if (error) {
                        error.hidden = false;
                        error.textContent = err.message || i18n.error || 'Error';
                    } else {
                        showToast(err.message || i18n.error || 'Error');
                    }
                } finally {
                    setButtonLoading(submit, false);
                }
            }
        });

        document.addEventListener('keydown', (event) => {
            if (event.key === 'Escape') {
                const modal = getModal();
                if (modal && !modal.hidden) {
                    closeModal();
                }
            }
        });
    }

    function initListing(root) {
        if (!root || root.dataset.shopReady === '1') {
            return;
        }
        root.dataset.shopReady = '1';

        const perPage = Math.max(1, Number(root.dataset.perPage || 9));
        const cards = Array.from(root.querySelectorAll('[data-shop-card]'));
        const filters = Array.from(root.querySelectorAll('[data-shop-filter]'));
        const statusNodes = Array.from(root.querySelectorAll('[data-shop-status]'));
        const prevBtns = Array.from(root.querySelectorAll('[data-shop-prev]'));
        const nextBtns = Array.from(root.querySelectorAll('[data-shop-next]'));

        if (!cards.length) {
            return;
        }

        let activeCategory = 'visi';
        let currentPage = 0;

        const cardMatchesCategory = (card, category) => {
            if (category === 'visi') {
                return true;
            }
            const raw = card.getAttribute('data-category') || '';
            return raw.split(/\s+/).filter(Boolean).includes(category);
        };

        const getFilteredCards = () =>
            cards.filter((card) => cardMatchesCategory(card, activeCategory));

        const update = () => {
            const filtered = getFilteredCards();
            const totalPages = Math.max(1, Math.ceil(filtered.length / perPage));

            if (currentPage > totalPages - 1) {
                currentPage = totalPages - 1;
            }
            if (currentPage < 0) {
                currentPage = 0;
            }

            cards.forEach((card) => {
                card.classList.remove('is-visible');
                card.setAttribute('hidden', '');
            });

            filtered.forEach((card, index) => {
                const page = Math.floor(index / perPage);
                card.setAttribute('data-page', String(page));

                if (page === currentPage) {
                    card.classList.add('is-visible');
                    card.removeAttribute('hidden');
                }
            });

            const label = `${currentPage + 1}/${totalPages}`;
            statusNodes.forEach((node) => {
                node.textContent = label;
            });

            const atStart = currentPage <= 0;
            const atEnd = currentPage >= totalPages - 1;

            prevBtns.forEach((btn) => {
                btn.disabled = atStart;
            });
            nextBtns.forEach((btn) => {
                btn.disabled = atEnd;
            });
        };

        filters.forEach((btn) => {
            btn.addEventListener('click', () => {
                // Archive uses <a> filters — don't hijack those
                if (btn.tagName === 'A') {
                    return;
                }
                activeCategory = btn.getAttribute('data-shop-filter') || 'visi';
                currentPage = 0;

                filters.forEach((item) => {
                    const active = item === btn;
                    item.classList.toggle('is-active', active);
                    item.setAttribute('aria-selected', active ? 'true' : 'false');
                });

                update();
            });
        });

        prevBtns.forEach((btn) => {
            btn.addEventListener('click', () => {
                currentPage -= 1;
                update();
            });
        });

        nextBtns.forEach((btn) => {
            btn.addEventListener('click', () => {
                currentPage += 1;
                update();
            });
        });

        update();
    }

    function boot() {
        initCartInteractions();
        document.querySelectorAll('[data-shop-products]').forEach(initListing);
        // Archive cards also need cart UI (no data-shop-products wrapper required beyond footer UI)
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', boot, { once: true });
    } else {
        boot();
    }
})();
